import Swiper from 'swiper/bundle';

export default new class ProductCarousel {
    constructor() {
        this.productsCarouselContainer = 'products-carousel__container';
        this.handler();

        this.navigation = {
            nextEl: '.products-carousel-next',
            prevEl: '.products-carousel-prev'
        };
    }

    handler() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initProductCarousel();
        });
    }

    initProductCarousel() {

        const { navigation } = this;

        this.productCarousel = new Swiper(`.${this.productsCarouselContainer}`, {
            slidesPerView: 4,
            autoplay: true,
            spaceBetween: 40,
            loop: true,
            navigation,
            speed: 2000,
        });
    }
}();
